import { createStyles, Theme } from "@material-ui/core";
export const expansionStyles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        position: 'relative',
        '&>:first-child': {
            boxShadow: 'none',
            '&>:first-child': {
                boxShadow: 'none',
            }
        },
    },
    expansionPanelExpanded: {
        margin: "2px 0px",
    },
    expansionPanelSummaryExpanded: {
        margin: "0 !important",
        padding: "12px 4px 12px 12px !important",
        minHeight: "21px !important",
        height: 40,
        right: 0,
    },
    expansionPanelSummaryContent: {
        margin: "0 !important",
        display: "flex",
        justifyContent: "space-between",
        '& p': {
            width: "420px",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            overflow: "hidden",
        }
    },
    rootcls: {
        minHeight: 40,
        "&$expanded": {
            margin: '12px 0',
            lineHeight: '37px'
        },
    },
    noContentTitle: {
        fontSize: 20,
        lineHeight: '24px',
        color: '#666'
    },
    noContentTxt: {
        fontSize: 14,
        lineHeight: '40px',
        color: '#999'
    },
    heading: {
        fontSize: 16,
        color: '#333',
        lineHeight: '22px',
        fontWeight: theme.typography.fontWeightRegular,
    },
    grayIcon: {
        filter: 'grayscale(1)',
        opacity: 0.7,
    },
    actionCTA: {
        position: 'absolute',
        right: 40,
        top: 12,
        zIndex: 9
    },
    actionCTA1: {
        position: 'absolute',
        right: 40,
        top: 5,
        zIndex: 9
    },
    checkBoxElement: {
        padding: '0px 7px',
        top: 0,
        width: 20,
        height: 20,
        '-moz-appearance': 'none',
        opacity: 1,
        color: 'rgb(204, 204, 204)',
        border: '1px solid #B2B2B2',
        borderRadius: 2,
        margin: '-4px 14px 0px 16px',
        '& svg': {
            fontSize: '1.5rem',
            fontFamily: '"Nunito", sans-serif',
            fill: '#979797',
            opacity: 0
        },
        '& span:nth-child(1)': {
            width: 24,
            zIndex: 9
        }
    },
    checkedCheckbox: {
        backgroundColor: '#1d7dea!important',
        border: '1px solid #1d7dea !important',
        borderRadius: 2,
        color: '#99a1a7',
        '&::after': {
            content: "''",
            fontSize: 14,
            position: 'absolute',
            top: 1,
            left: 6,
            width: 4,
            height: 10,
            border: 'solid #fff',
            borderWidth: '0 2px 2px 0',
            transform: 'rotate(45deg)'
        },
        '&:hover': {
            backgroundColor: '#1d7dea'
        }
    },
    chipUI: {
        background: "#FF9533",
        color: "#fff",
        fontSize: 12,
    },
    expentionMain: {
        '&>:last-child': {
            borderBottom: 'none',
            paddingTop: '25px',
            alignItems: 'center',
        }
    },
    borderBottomGray: {
        borderBottom: '1px solid rgba(153, 153, 153, 0.5)',
        padding: '10px 0 5px 0'
    },
    subName: {
        color: "#333",
        display: "block",
        position: "relative",
        fontSize: 16,
        fontWeight: 200,
        minWidth: 300,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        width: "100%",
        maxWidth: 300,
    },
    proficiency: {
        fontSize: 14,
        fontWeight: 200,
        color: '#333',
    },
    subImage: {
        display: 'flex',
        alignItems: 'center',
        // width: 420,
        // overflow: 'hidden',
        // whiteSpace: 'nowrap',
        // textOverflow: 'ellipsis',
        '&>img': {
            verticalAlign: 'top',
            width: 25,
        }
    },
    padding0: {
        padding: '0px 0px 0px 16px'
    },
    redDot: {
        top: '-1px',
        width: '10px',
        right: '-3px',
        height: '10px',
        position: 'absolute',
        borderRadius: '50%',
        backgroundColor: '#ff3b3b',
    },
});